export default "__VITE_ASSET__40694ef0__"